import { defineComponent as _defineComponent } from 'vue';
import HelpPopover from "./HelpPopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HelpText',
    props: {
        uri: null,
        text: null,
        forTitle: { type: Boolean, default: false }
    },
    setup(__props) {
        return { __sfc: true, HelpPopover };
    }
});
